import React, { memo } from 'react';
export var Warning = /*#__PURE__*/memo(function (_ref) {
  var _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'exclamation-point' : _ref$alt,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#40889C' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    alt: alt,
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---MBP-Catagory-Page---Best-Picks---Desktop-No-b.-Sure-Branding-3-Cards",
    transform: "translate(-362.000000, -4115.000000)",
    fill: fill
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-5---Our-Reviews-1---Vast",
    transform: "translate(360.000000, 3758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Review-1---Vast",
    transform: "translate(0.000000, 0.614793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-List",
    transform: "translate(1.000000, 288.385207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line3",
    transform: "translate(1.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_warn_sm",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7499999,3.75 L11.2499999,3.75 L11.2499999,11.25 L8.7499999,11.25 L8.7499999,3.75 Z M8.7499999,13.749996 L11.2499999,13.749996 L11.2499999,16.249996 L8.7499999,16.249996 L8.7499999,13.749996 Z M10,1.0658141e-14 L10,1.0658141e-14 C15.5231279,1.0658141e-14 20,4.47687 20,10 C20,15.523121 15.5231279,20 10,20 C4.4768749,20 1.90070182e-13,15.523121 1.90070182e-13,10 C1.90070182e-13,4.47687 4.4768749,1.0658141e-14 10,1.0658141e-14 L10,1.0658141e-14 Z M9.9999979,1.875 C7.8299999,1.875 5.7893749,2.72 4.2549999,4.255 C2.7199999,5.78937 1.8749999,7.83 1.8749999,10 C1.8749999,12.169996 2.7199999,14.210621 4.2549999,15.744996 C5.7893749,17.279996 7.8299999,18.124996 9.9999979,18.124996 C12.1699979,18.124996 14.2106279,17.279996 15.7449979,15.744996 C17.2799979,14.210621 18.1249979,12.169996 18.1249979,10 C18.1249979,7.83 17.2799979,5.78937 15.7449979,4.255 C14.2106279,2.72 12.1699979,1.875 9.9999979,1.875 L9.9999979,1.875 Z",
    id: "Fill-1"
  })))))))));
});